import { render } from "./Pdf.vue?vue&type=template&id=a7c0956c"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\autfis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__